var map = {
	"./swiper1.png": 4208,
	"./swiper11.png": 1851,
	"./swiper12 .png": 3874,
	"./swiper13.png": 5257,
	"./swiper2.png": 2539,
	"./swiper3.png": 4674,
	"./swiper5.png": 884
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7983;